<div class="modal-header">
  <h4 class="modal-title" id="modal-basic-title">{{title}}</h4>
  <button type="button" class="close" aria-label="Close" (click)="activeModal.dismiss('Cross click')">
    <span aria-hidden="true">&times;</span>
  </button>
</div>
<div class="modal-body" style="padding:0;">
  <wol-foldertree (setSelectedFolder)="setSelectedFolder($event)"></wol-foldertree>
</div>
<div class="modal-footer">
  <button type="button" class="btn btn-outline-dark" (click)="activeModal.dismiss('cancel click')">cancel</button>
  <button type="button" class="btn btn-primary" ngbAutofocus (click)="activeModal.close(selectedfolder)">{{type}}</button>
</div>
